"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_0.ts
const product_types_1 = require("../types/product.types");
const products = [
    // Educación vial para la seguridad. Aplicación policial
    {
        id: 859,
        tax: 0.0,
        sku: "iopos.course.online.curso-educacion-vial-seguridad-aplicacion-policial-2026",
        title: "Curs d'Educació Vial per a la Seguretat. Aplicació Policial",
        name: "Curs d'Educació Vial per a la Seguretat. Aplicació Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: " Formació especialitzada orientada a la prevenció d’accidents i a la promoció d’una cultura de mobilitat segura mitjançant l’educació viària aplicada.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/859/image1"],
        banner: ["/859/image1"],
        link: "/tienda/cursos/formacion-policial/curso-educacion-vial-para-la-seguridad-aplicacion-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [860, 861],
        multiple_languages: false,
    },
    // Curso de Educación Vial para la Seguridad. Aplicación Policial - Idiomas
    {
        id: 860,
        tax: 0.0,
        sku: "iopos.course.online.curso-educacion-vial-seguridad-aplicacion-policial-2026-es",
        title: "Curso de Educación Vial para la Seguridad. Aplicación Policial",
        name: "Curso de Educación Vial para la Seguridad. Aplicación Policial",
        short: "1.) Educación Vial para la Seguridad. Aplicación Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curso enfocado en el papel de la policía en la promoción de la educación vial como herramienta preventiva. Incluye contenidos sobre intervenciones educativas, campañas de concienciación, trabajo con colectivos vulnerables y normativa aplicable.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/859/image1"],
        banner: ["/859/image1"],
        link: "/tienda/cursos/formacion-policial/curso-de-educacion-vial-para-la-seguridad-aplicacion-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 859,
        default_in_parent: true,
        evolmind: { course_id: 819, group_id: [2514] },
    },
    // Curs d'Educació Vial per a la Seguretat. Aplicació Policial - Idiomes
    {
        id: 861,
        tax: 0.0,
        sku: "iopos.course.online.curso-educacion-vial-seguridad-aplicacion-policial-2026-ca",
        title: "Curs d'Educació Vial per a la Seguretat. Aplicació Policial",
        name: "Curs d'Educació Vial per a la Seguretat. Aplicació Policial",
        short: "1.) Educació Vial per a la Seguretat. Aplicació Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curs centrat en el paper de la policia en la promoció de l'educació viària com a eina preventiva. Inclou continguts sobre intervencions educatives, campanyes de conscienciació, treball amb col·lectius vulnerables i normativa aplicable.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/859/image1"],
        banner: ["/859/image1"],
        link: "/tienda/cursos/formacion-policial/curso-de-educacion-vial-para-la-seguridad-aplicacion-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 859,
        evolmind: { course_id: 816, group_id: [2511] },
    },
    // Accidentes por atropello: Investigación y reconstrucción
    {
        id: 862,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidentes-atropello-investigacion-reconstruccion-2026",
        title: "Curso de Accidentes por Atropello: Investigación y Reconstrucción",
        name: "Curso de Accidentes por Atropello: Investigación y Reconstrucción",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curso especializado en la investigación técnica y policial de accidentes por atropello. Se abordan metodologías de reconstrucción, análisis de la escena, recogida de pruebas, elaboración de informes y normativa aplicable.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/862/image1"],
        banner: ["/862/image1"],
        link: "/tienda/cursos/formacion-policial/curso-accidentes-por-atropello-investigacion-y-reconstruccion-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [863, 864],
        multiple_languages: false,
    },
    // Curso de Accidentes por Atropello: Investigación y Reconstrucción - Idiomas
    {
        id: 863,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidentes-atropello-investigacion-reconstruccion-2026-es",
        title: "Curso de Accidentes por Atropello: Investigación y Reconstrucción",
        name: "Curso de Accidentes por Atropello: Investigación y Reconstrucción",
        short: "1.) Accidentes por Atropello: Investigación y Reconstrucción",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curso especializado en la investigación técnica y policial de accidentes por atropello. Se abordan metodologías de reconstrucción, análisis de la escena, recogida de pruebas, elaboración de informes y normativa aplicable.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/862/image1"],
        banner: ["/862/image1"],
        link: "/tienda/cursos/formacion-policial/curso-accidentes-por-atropello-investigacion-y-reconstruccion-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 862,
        default_in_parent: true,
        evolmind: { course_id: 822, group_id: [2517] },
    },
    // Curs d'Accidents per Atropellament: Investigació i Reconstrucció - Idiomes
    {
        id: 864,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidentes-atropello-investigacion-reconstruccion-2026-ca",
        title: "Curs d'Accidents per Atropellament: Investigació i Reconstrucció",
        name: "Curs d'Accidents per Atropellament: Investigació i Reconstrucció",
        short: "2.) Accidents per Atropellament: Investigació i Reconstrucció",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curs especialitzat en la investigació tècnica i policial d'accidents per atropellament. S'hi aborden metodologies de reconstrucció, anàlisi de l'escena, recollida de proves, elaboració d'informes i normativa aplicable.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/862/image1"],
        banner: ["/862/image1"],
        link: "/tienda/cursos/formacion-policial/curso-de-accidentes-por-atropello-investigacion-y-reconstruccion-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 862,
        evolmind: { course_id: 825, group_id: [2520] },
    },
    // Curso de Defensa Extensible Policial
    {
        id: 865,
        tax: 0.21,
        sku: "iopos.course.online.curso-defensa-extensible-policial-2026",
        title: "Curs de Defensa Extensible Policial",
        name: "Curs de Defensa Extensible Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació especialitzada orientada a garantir un ús legal, proporcional i tècnicament segur de la defensa extensible policial com a eina no letal dins l’escala progressiva de la força.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/865/image1"],
        banner: ["/865/image1"],
        link: "/tienda/cursos/formacion-policial/curso-defensa-extensible-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [866, 867],
        multiple_languages: false,
    },
    // Curso de Defensa Extensible Policial - Idiomas ES
    {
        id: 866,
        tax: 0.21,
        sku: "iopos.course.online.curso-defensa-extensible-policial-2026-es",
        title: "Curso de Defensa Extensible Policial",
        name: "Curso de Defensa Extensible Policial",
        short: "1.) Defensa Extensible Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Domina el uso profesional, legal y eficaz de la defensa extensible en intervencionespoliciales. Este curso está diseñado para agentes en activo y aspirantes, y ofrece una formación completa en técnicas defensivas, normativa vigente yprincipios de proporcionalidad y oportunidad en su uso.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/865/image1"],
        banner: ["/865/image1"],
        link: "/tienda/cursos/formacion-policial/curso-defensa-extensible-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 865,
        default_in_parent: true,
        evolmind: { course_id: 828, group_id: [2523] },
    },
    // Curs de Defensa Extensible Policial - Idiomas CA
    {
        id: 867,
        tax: 0.21,
        sku: "iopos.course.online.curso-defensa-extensible-policial-2026-ca",
        title: "Curs de Defensa Extensible Policial",
        name: "Curs de Defensa Extensible Policial",
        short: "1.) Defensa Extensible Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/865/image1"],
        banner: ["/865/image1"],
        link: "/tienda/cursos/formacion-policial/curso-defensa-extensible-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 865,
        evolmind: { course_id: 831, group_id: [2526] },
    },
    // Intervencion Policial ante Armas Prohibidas y Reglamentadas
    {
        id: 868,
        tax: 0.0,
        sku: "iopos.course.online.curso-intervencion-policial-armas-prohibidas-reglamentadas-2026",
        title: "Curso Intervención Policial Armas Prohibidas y Reglamentadas",
        name: "Curso Intervención Policial Armas Prohibidas y Reglamentadas",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Curso especializado en la identificación, análisis y actuación operativa frente a armas prohibidas y reglamentadas. Aprende areconocerlas, intervenir con seguridad y actuar conforme a la normativa vigente. Formación esencial para agentes en activo y futuros policías.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/868/image1"],
        banner: ["/868/image1"],
        link: "/tienda/cursos/formacion-policial/curso-intervencion-policial-ante-armas-prohibidas-reglamentadas-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [869, 870],
        multiple_languages: false,
    },
    // Curso Intervención Policial ante Armas Prohibidas y Reglamentadas - Idiomas
    {
        id: 869,
        tax: 0.0,
        sku: "iopos.course.online.curso-intervencion-policial-armas-prohibidas-reglamentadas-2026-es",
        title: "Curso Intervención Policial ante Armas Prohibidas y Reglamentadas",
        name: "Curso Intervención Policial ante Armas Prohibidas y Reglamentadas",
        short: "1.) Intervención Policial ante Armas Prohibidas y Reglamentadas",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Curso especializado en la identificación, análisis y actuación operativa frente a armas prohibidas y reglamentadas. Aprende areconocerlas, intervenir con seguridad y actuar conforme a la normativa vigente. Formación esencial para agentes en activo y futuros policías.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/868/image1"],
        banner: ["/868/image1"],
        link: "/tienda/cursos/formacion-policial/curso-intervencion-policial-ante-armas-prohibidas-y-reglamentadas-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 865,
        default_in_parent: true,
        evolmind: { course_id: 834, group_id: [2529] },
    },
    // Curs d'Intervenció Policial davant d'Armes Prohibides i Reglamentades - Idiomes
    {
        id: 870,
        tax: 0.0,
        sku: "iopos.course.online.curso-intervencion-policial-armas-prohibidas-reglamentadas-2026-ca",
        title: "Curs d'Intervenció Policial davant d'Armes Prohibides i Reglamentades",
        name: "Curs d'Intervenció Policial davant d'Armes Prohibides i Reglamentades",
        short: "2.) Intervenció Policial davant d'Armes Prohibides i Reglamentades",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Curs especialitzat en la identificació, anàlisi i actuacióoperativa davant armes prohibides i reglamentades. Aprèn a reconèixer-les, intervenir amb seguretat i actuar segons la normativa vigent. Formacióessencial per a agents en actiu i futurs policies.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/868/image1"],
        banner: ["/868/image1"],
        link: "/tienda/cursos/formacion-policial/curso-intervencion-policial-ante-armas-prohibidas-y-reglamentadas-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 868,
        evolmind: { course_id: 837, group_id: [2532] },
    },
    // Especialista en procedimientos integrales de detención policial y derechos del detenido
    {
        id: 871,
        tax: 0.0,
        sku: "iopos.course.online.curso-especialista-procedimientos-integrales-detencion-derechos-2026",
        title: "Curso Especialista en Procedimientos Integrales de Detención Policial y Derechos del Detenido",
        name: "Curso Especialista en Procedimientos Integrales de Detención Policial y Derechos del Detenido",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Fórmate como especialista en actuaciones policiales con personas detenidas. Conoce los procedimientos legales, operativos y de garantía de derechos. Una formación clave para una actuación segura, ética y profesional.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/871/image1"],
        banner: ["/871/image1"],
        link: "/tienda/cursos/formacion-policial/curso-especialista-procedimientos-integrales-detencion-policial-y-detechos-detenido-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [872, 873],
        multiple_languages: false,
    },
    // Curso Especialista en Procedimientos Integrales de Detención Policial y Derechos del Detenido - Idiomas
    {
        id: 872,
        tax: 0.0,
        sku: "iopos.course.online.curso-especialista-procedimientos-integrales-detencion-derechos-2026-es",
        title: "Curso Especialista en Procedimientos Integrales de Detención Policial y Derechos del Detenido",
        name: "Curso Especialista en Procedimientos Integrales de Detención Policial y Derechos del Detenido",
        short: "1.) Especialista en Procedimientos Integrales de Detención Policial y Derechos del Detenido",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Fórmate como especialista en actuaciones policiales con personas detenidas. Conoce los procedimientos legales, operativos y de garantía de derechos. Una formación clave para una actuación segura, ética y profesional.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/871/image1"],
        banner: ["/871/image1"],
        link: "/tienda/cursos/formacion-policial/curso-especialista-procedimientos-integrales-detencion-policial-y-detechos-detenido-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 871,
        default_in_parent: true,
        evolmind: { course_id: 840, group_id: [2535] },
    },
    // Curs d'Especialista en Procediments Integrals de Detenció Policial i Drets del Detingut - Idiomas
    {
        id: 873,
        tax: 0.0,
        sku: "iopos.course.online.curso-especialista-procedimientos-integrales-detencion-derechos-2026-ca",
        title: "Curs d'Especialista en Procediments Integrals de Detenció Policial i Drets del Detingut",
        name: "Curs d'Especialista en Procediments Integrals de Detenció Policial i Drets del Detingut",
        short: "2.) Especialista en Procediments Integrals de Detenció Policial i Drets del Detingut",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Forma't com a especialista en les actuacions policials amb persones detingudes. Coneix els procediments legals, operatius i de garantia de drets. Una formació clau per a una actuació segura, ètica i professional.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/871/image1"],
        banner: ["/871/image1"],
        link: "/tienda/cursos/formacion-policial/curso-especialista-procedimientos-integrales-detencion-policial-y-detechos-detenido-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 871,
        evolmind: { course_id: 843, group_id: [2538] },
    },
    // Curso Superior Experto en Intervención Policial en Violencia de Género y Doméstica
    {
        id: 874,
        tax: 0.0,
        sku: "iopos.course.online.curso-violencia-domestica-2026",
        title: "Curs Violència Domèstica",
        name: "Curs Violència Domèstica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals policials en la intervenció integral davant casos de violència domèstica i de gènere, amb criteri jurídic, psicològic i operatiu.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/874/image1"],
        banner: ["/874/image1"],
        link: "/tienda/cursos/formacion-policial/curso-violencia-domestica-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [875, 876],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070890",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Violència Domèstica",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **capacitar** els **professionals policials** en la **intervenció integral** davant casos de **violència domèstica** i de **gènere**, amb **criteri jurídic**, **psicològic** i **operatiu**.",
            landscape: "/874/hero_h",
            portrait: "/874/hero_v",
        },
    },
    // Curso Superior Experto en Intervención Policial en Violencia de Género y Doméstica - Idiomas
    {
        id: 875,
        tax: 0.0,
        sku: "iopos.course.online.curso-violencia-domestica-2026-es",
        title: "Curso Violencia Doméstica",
        name: "Curso Violencia Doméstica",
        short: "1.) Violencia Doméstica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Fórmate como especialista en actuaciones policiales con personas detenidas. Conoce los procedimientos legales, operativos y de garantía de derechos. Una formación clave para una actuación segura, ética y profesional.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/874/image1"],
        banner: ["/874/image1"],
        link: "/tienda/cursos/formacion-policial/curso-violencia-domestica-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 874,
        default_in_parent: true,
        evolmind: { course_id: 846, group_id: [2541] },
    },
    // Curso Superior d'Expert en Intervenció Policial en Violència de Gènere i Domèstica - Idiomas
    {
        id: 876,
        tax: 0.0,
        sku: "iopos.course.online.curso-violencia-domestica-2026-ca",
        title: "Curs Violència Domèstica",
        name: "Curs Violència Domèstica",
        short: "1.) Violència Domèstica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Especialitza't en intervencions policials en casos de violència de gènere i àmbit domèstic. Aprèn protocols d'actuació, detecció de risc i protecció de víctimes. Una formació essencial per actuar amb sensibilitat, rigor i eficàcia.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/874/image1"],
        banner: ["/874/image1"],
        link: "/tienda/cursos/formacion-policial/curso-violencia-domestica-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 874,
        evolmind: { course_id: 849, group_id: [2544] },
    },
    // Protección de Personas y Bienes. Control de Paso y Dispositivos Estáticos de Control
    {
        id: 877,
        tax: 0.21,
        sku: "iopos.course.online.curso-proteccion-personas-bienes-2026",
        title: "Curs Protecció de Persones i Béns",
        name: "Curs Protecció de Persones i Béns",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació operativa especialitzada orientada a millorar l’actuació policial en controls estàtics i de pas, intervencions de seguretat ciutadana i mesures d’autoprotecció, amb ple respecte al marc jurídic vigent.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/877/image1"],
        banner: ["/877/image1"],
        link: "/tienda/cursos/formacion-policial/curso-proteccion-personas-bienes-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [878, 879],
        multiple_languages: false,
    },
    // Curso Protección de Personas y Bienes. Control de Paso y Dispositivos Estáticos de Control - Idiomas
    {
        id: 878,
        tax: 0.21,
        sku: "iopos.course.online.curso-proteccion-personas-bienes-2026-es",
        title: "Curso Protección de Personas y Bienes",
        name: "Curso Protección de Personas y Bienes",
        short: "1.) Protección de Personas y Bienes",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Adquiere competencias clave en la protección de personas, bienes y espacios sensibles. Domina los dispositivos estáticos de control y la gestión de puntos de paso. Una formación orientada a la seguridad preventiva y la eficacia operativa. ",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/877/image1"],
        banner: ["/877/image1"],
        link: "/tienda/cursos/formacion-policial/curso-proteccion-personas-bienes-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 877,
        default_in_parent: true,
        evolmind: { course_id: 852, group_id: [2547] },
    },
    // Curs Protecció de Persones i Béns. Control de Pas i Dispositius Estàtics de Control - Idiomas
    {
        id: 879,
        tax: 0.21,
        sku: "iopos.course.online.curso-proteccion-personas-bienes-2026-ca",
        title: "Curs Protecció de Persones i Béns",
        name: "Curs Protecció de Persones i Béns",
        short: "1.) Protecció de Persones i Béns",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/877/image1"],
        banner: ["/877/image1"],
        link: "/tienda/cursos/formacion-policial/curso-proteccion-personas-bienes-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 877,
        evolmind: { course_id: 855, group_id: [2550] },
    },
    // 880. Documentoscopia Policial
    {
        id: 880,
        tax: 0.0,
        sku: "iopos.course.online.curso-documentoscopia-policial-2026",
        title: "Curs en Documentoscopia Policial",
        name: "Curs en Documentoscopia Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Formació especialitzada orientada a identificar, analitzar i detectar falsificacions documentals amb criteri tècnic, rigor pericial i seguretat jurídica.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/880/image2"],
        banner: ["/880/image2"],
        link: "/tienda/cursos/formacion-policial/curso-documentoscopia-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [881, 882],
        multiple_languages: false,
    },
    // Curso en Documentoscopia Policial - Idiomas
    {
        id: 881,
        tax: 0.0,
        sku: "iopos.course.online.curso-documentoscopia-policial-2026-es",
        title: "Curso en Documentoscopia Policial",
        name: "Curso en Documentoscopia Policial",
        short: "1.) Documentoscopia Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Aprende a identificar documentos falsificados con técnicas de documentoscopia policial. Conoce los elementos de seguridad y los procedimientos de verificación documental. Una formación técnica clave para prevenir el fraude y garantizar la actuación legal",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/880/image1"],
        banner: ["/880/image1"],
        link: "/tienda/cursos/formacion-policial/curso-documentoscopia-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 880,
        default_in_parent: true,
        evolmind: { course_id: 858, group_id: [2553] },
    },
    // Curs en Documentoscopia Policial - Idiomas
    {
        id: 882,
        tax: 0.0,
        sku: "iopos.course.online.curso-documentoscopia-policial-2026-ca",
        title: "Curs en Documentoscopia Policial",
        name: "Curs en Documentoscopia Policial",
        short: "1.) Documentoscopia Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Aprèn a identificar documents falsificats amb tècniques de documentoscòpia policial. Coneix els elements de seguretat i els procediments de verificació documental. Una formació tècnica clau per prevenir el frau i garantir l'actuació legal",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/880/image1"],
        banner: ["/880/image1"],
        link: "/tienda/cursos/formacion-policial/curso-documentoscopia-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 880,
        evolmind: { course_id: 861, group_id: [2556] },
    },
    // Investigación Policial de Incendios
    {
        id: 883,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-incendios-2026",
        title: "Curso en Investigación Policial de Incendios",
        name: "Curso en Investigación Policial de Incendios",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Fórmate en la investigación del origen y causas de incendios con criterios técnicos y policiales. Aprende a analizar indicios, preservar pruebas y colaborar con bomberos y peritos. Una formación especializada para actuar con rigor y eficacia investigadora.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/883/image1"],
        banner: ["/883/image1"],
        link: "/tienda/cursos/formacion-policial/curso-investigacion-policial-de-incendios-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [884, 885],
        multiple_languages: false,
    },
    // Curso en Investigación Policial de Incendios - ES
    {
        id: 884,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-incendios-2026-es",
        title: "Curso en Investigación Policial de Incendios",
        name: "Curso en Investigación Policial de Incendios",
        short: "1.) Investigación Policial de Incendios",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Fórmate en la investigación del origen y causas de incendios con criterios técnicos y policiales. Aprende a analizar indicios, preservar pruebas y colaborar con bomberos y peritos. Una formación especializada para actuar con rigor y eficacia investigadora.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/883/image1"],
        banner: ["/883/image1"],
        link: "/tienda/cursos/formacion-policial/curso-en-investacion-policia-de-incendios-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 883,
        default_in_parent: true,
        evolmind: { course_id: 864, group_id: [2559] },
    },
    // Curs en Investigació Policial d'Incendis - Idiomes
    {
        id: 885,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-incendios-2026-ca",
        title: "Curs en Investigació Policial d'Incendis",
        name: "Curs en Investigació Policial d'Incendis",
        short: "2.) Investigació Policial d'Incendis",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Forma't en la investigació de l'origen i causes d'incendis amb criteris tècnics i policials. Aprèn a analitzar indicis, preservar proves i col·laborar amb bombers i perits. Una formació especialitzada per actuar amb rigor i eficàcia investigadora.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/883/image1"],
        banner: ["/883/image1"],
        link: "/tienda/cursos/formacion-policial/curso-investigacion-policial-de-incendios-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 883,
        evolmind: { course_id: 867, group_id: [2562] },
    },
    // Investigación Policial en Crimen Organizado
    {
        id: 886,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-crimen-organizado-2026",
        title: "Curs d'Investigació Policial en Crim Organitzat",
        name: "Curs d'Investigació Policial en Crim Organitzat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Formació especialitzada orientada a comprendre, analitzar i investigar el fenomen del crim organitzat amb criteri professional, rigor analític i seguretat jurídica.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/886/image2"],
        banner: ["/886/image2"],
        link: "/tienda/cursos/formacion-policial/curso-en-investacion-policial-crimen-organizado-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [887, 888],
        multiple_languages: false,
    },
    // Curso en Investigación Policial en Crimen Organizado - Idiomas
    {
        id: 887,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-crimen-organizado-2026-es",
        title: "Curso en Investigación Policial en Crimen Organizado",
        name: "Curso en Investigación Policial en Crimen Organizado",
        short: "1.) Investigación Policial en Crimen Organizado",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Adquiere habilidades para investigar estructuras y delitos del crimen organizado. Conoce técnicas de inteligencia, análisis operativo y trabajo interagencial. Una formación avanzada para afrontar las redes criminales con eficacia.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/886/image1"],
        banner: ["/886/image1"],
        link: "/tienda/cursos/formacion-policial/curso-en-investacion-policial-crimen-organizado-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 886,
        default_in_parent: true,
        evolmind: { course_id: 870, group_id: [2565] },
    },
    // Curs d'Investigació Policial en Crim Organitzat - Idiomes
    {
        id: 888,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-crimen-organizado-2026-ca",
        title: "Curs d'Investigació Policial en Crim Organitzat",
        name: "Curs d'Investigació Policial en Crim Organitzat",
        short: "1.) Investigación Policial en Crimen Organizado",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Adquireix habilitats per investigar estructures i delictes del crim organitzat. Coneix tècniques d'intel·ligència, anàlisi operativa i treball interagències. Una formació avançada per afrontar les xarxes criminals amb eficàcia.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/886/image1"],
        banner: ["/886/image1"],
        link: "/tienda/cursos/formacion-policial/curso-investigacion-policial-crimen-organizado-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 886,
        evolmind: { course_id: 873, group_id: [2568] },
    },
    // Policía Científica
    {
        id: 889,
        tax: 0.0,
        sku: "iopos.course.online.curso-policia-centifica-2026",
        title: "Curs en Policia Científica",
        name: "Curs en Policia Científica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Formació especialitzada orientada a aplicar mètodes científics en la investigació policial, garantint el rigor tècnic, la validesa probatòria i la seguretat jurídica.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/889/image1"],
        banner: ["/889/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-cientifica-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [890, 891],
        multiple_languages: false,
    },
    // Curso en Policía Científica - Idiomas
    {
        id: 890,
        tax: 0.0,
        sku: "iopos.course.online.curso-policia-centifica-2026-es",
        title: "Curso en Policía Científica",
        name: "Curso en Policía Científica",
        short: "1.) Policía Científica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Adéntrate en las técnicas forenses aplicadas a la investigación policial. Aprende a gestionar la escena del crimen, recoger indicios y analizar pruebas. Una formación esencial para garantizar la cadena de custodia y el valor probatorio. ",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/889/image1"],
        banner: ["/889/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-cientifica-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 889,
        default_in_parent: true,
        evolmind: { course_id: 876, group_id: [2571] },
    },
    // Curs en Policia Científica - Idiomes
    {
        id: 891,
        tax: 0.0,
        sku: "iopos.course.online.curso-policia-centifica-2026-ca",
        title: "Curs en Policia Científica",
        name: "Curs en Policia Científica",
        short: "1.) Policia Científica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Endinsa't en les tècniques forenses aplicades a la investigació policial. Aprèn a gestionar l'escena del crim, recollir indicis i analitzar proves. Una formació essencial per garantir la cadena de custòdia i el valor probatori.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/889/image1"],
        banner: ["/889/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-cientifica-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 889,
        evolmind: { course_id: 879, group_id: [2574] },
    },
    // Introducción a la Criminología y Práctica Policial
    {
        id: 892,
        tax: 0.0,
        sku: "iopos.course.online.curso-criminologia-herramientas-y-aplicaciones-policiales-2026",
        title: "Curs Criminologia: Eines i Aplicacions Policials",
        name: "Curs Criminologia: Eines i Aplicacions Policials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a comprendre el fenomen criminal des d’una perspectiva científica, preventiva i aplicada a la pràctica policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/892/image2"],
        banner: ["/892/image2"],
        link: "/tienda/cursos/formacion-policial/curso-criminologia-practica-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [893, 894],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070867",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Criminologia: Eines i Aplicacions Policials",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **comprendre** el **fenomen criminal** des d'una perspectiva **científica**, **preventiva** i aplicada a la **pràctica policial**.",
            landscape: "/892/hero_h",
            portrait: "/892/hero_v",
        },
    },
    // Curso Introducción a la Criminología y Práctica Policial - Idiomas
    {
        id: 893,
        tax: 0.0,
        sku: "iopos.course.online.curso-criminologia-herramientas-y-aplicaciones-policiales-2026-es",
        title: "Curso Criminología y Práctica Policial",
        name: "Curso Criminología y Práctica Policial",
        short: "1.) Criminología y Práctica Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Descubre las bases de la criminología y su aplicación en el ámbito policial. Analiza el comportamiento delictivo, la prevención y la respuesta operativa. Una formación fundamental para comprender el delito y actuar con criterio profesional.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/892/image1"],
        banner: ["/892/image1"],
        link: "/tienda/cursos/formacion-policial/curso-criminologia-practica-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 892,
        default_in_parent: true,
        evolmind: { course_id: 882, group_id: [2577] },
    },
    // Curs d'Introducció a la Criminologia i Pràctica Policial - Idiomes
    {
        id: 894,
        tax: 0.0,
        sku: "iopos.course.online.curso-criminologia-herramientas-y-aplicaciones-policiales-2026-ca",
        title: "Curs Criminologia: Eines i Aplicacions Policials",
        name: "Curs Criminologia: Eines i Aplicacions Policials",
        short: "1.) Criminologia: Eines i Aplicacions Policials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Descobreix les bases de la criminologia i la seva aplicació en l'àmbit policial. Analitza el comportament delictiu, la prevenció i la resposta operativa. Una formació fonamental per entendre el delicte i actuar amb criteri professional.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/892/image1"],
        banner: ["/892/image1"],
        link: "/tienda/cursos/formacion-policial/curso-criminologia-practica-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 892,
        evolmind: { course_id: 885, group_id: [2580] },
    },
    // Detección e Intervención con Grafiteros
    {
        id: 895,
        tax: 0.0,
        sku: "iopos.course.online.curso-deteccion-intervencion-grafiteros-2026",
        title: "Curs en Detecció i Intervenció amb Grafiters",
        name: "Curs en Detecció i Intervenció amb Grafiters",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Formació especialitzada orientada a detectar, interpretar i intervenir davant grafits il·legals amb criteri operatiu, seguretat jurídica i visió preventiva.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/895/image2"],
        banner: ["/895/image2"],
        link: "/tienda/cursos/formacion-policial/curso-deteccion-intervencion-grafiteros-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [896, 897],
        multiple_languages: false,
    },
    // Curso en Detección e Intervención con Grafiteros - Idiomas
    {
        id: 896,
        tax: 0.0,
        sku: "iopos.course.online.curso-deteccion-intervencion-grafiteros-2026-es",
        title: "Curso en Detección e Intervención con Grafiteros",
        name: "Curso en Detección e Intervención con Grafiteros",
        short: "1.) Detección e Intervención con Grafiteros",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Especialízate en la detección e intervención policial ante actos vandálicos con grafitis. Conoce perfiles, dinámicas y estrategias operativas efectivas. Una formación práctica para proteger el espacio público y actuar con proporcionalidad.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/895/image1"],
        banner: ["/895/image1"],
        link: "/tienda/cursos/formacion-policial/curso-deteccion-intervencion-grafiteros-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 895,
        default_in_parent: true,
        evolmind: { course_id: 888, group_id: [2583] },
    },
    // Curs en Detecció i Intervenció amb Grafiters - Idiomes
    {
        id: 897,
        tax: 0.0,
        sku: "iopos.course.online.curso-deteccion-intervencion-grafiteros-2026-ca",
        title: "Curs en Detecció i Intervenció amb Grafiters",
        name: "Curs en Detecció i Intervenció amb Grafiters",
        short: "1.) Detecció i Intervenció amb Grafiters",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Especialitza't en la detecció i intervenció policial davant d'actes vandàlics amb grafits. Coneix perfils, dinàmiques i estratègies operatives efectives. Una formació pràctica per protegir l'espai públic i actuar amb proporcionalitat.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/895/image1"],
        banner: ["/895/image1"],
        link: "/tienda/cursos/formacion-policial/curso-deteccion-intervencion-grafiteros-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 895,
        evolmind: { course_id: 891, group_id: [2586] },
    },
    // Formació Grupal RolePlay (Especial Terrassa 2025 - 5 juliol)
    {
        id: 898,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL, product_types_1.Category.Interviews],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.formacio-grupal-roleplay-especial-terrassa-2025-5-juliol",
        title: "Formació Grupal RolePlay (Especial Terrassa 2025 - 5 juliol)",
        name: "Formació Grupal RolePlay (Especial Terrassa 2025 - 5 juliol)",
        description: "Diferencia't dels altres candidats! Viu una experiència 100% pràctica i immersiva que et prepara per superar amb èxit les entrevistes i dinàmiques de grup de qualsevol procés selectiu.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        price: 89.99,
        shipment: 0.0,
        images: ["/705/image2"],
        banner: ["/705/image2"],
        link: "/tienda/cursos/entrevista-grupal-roleplay-policia-local-especial-terrassa-2025-5-juliol/",
        created_at: "2025-06-20 00:00:01",
        start_at: "2025-06-20 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
    },
    // Les 1001 preguntes imprescindibles per ser Guàrdia Urbana de Barcelona
    {
        id: 899,
        tax: 0.04,
        sku: "iopos.book.les-1001-preguntes-imprescindibles-per-ser-gub",
        title: "Les 1001 preguntes imprescindibles per ser Guàrdia Urbana de Barcelona",
        name: "Les 1001 preguntes imprescindibles per ser Guàrdia Urbana de Barcelona",
        description: "El llibre imprescindible per dominar els 38 temes oficials i destacar a la convocatòria de 2025",
        enabled: true,
        stock: true,
        stock_message: "Actualment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB],
        price: 59.99,
        // offer: 59.99,
        // offer_text: "A per l'Oposició!",
        images: ["/899/image1"],
        banner: ["/899/image1"],
        shipment: 4.49,
        link: "/tienda/libros/les-1001-preguntes-imprescindibles-per-ser-guardia-urbana-de-barcelona/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [132], duration: 12 },
        created_at: "2025-06-27 00:00:01",
        start_at: "2025-06-27 00:00:01",
        updated_at: "2025-06-27 00:00:01",
        limit: 50,
        weight: 723,
    },
    // Pack Temari Guàrdia Urbana de Barcelona 2025
    {
        id: 900,
        tax: 0.04,
        sku: "iopos.book.pack-temari-guardia-urbana-barcelona-2025",
        title: "Pack Temari Guàrdia Urbana de Barcelona 2025",
        name: "Pack Temari Guàrdia Urbana de Barcelona 2025",
        description: "Els 3 volums imprescindibles per dominar els 38 temes oficials de l'oposició",
        enabled: true,
        stock: false,
        stock_message: "Sense estoc!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB],
        price: 119.99,
        // offer: 119.99,
        // offer_text: "A per l'Oposició!",
        images: ["/900/image2"],
        banner: ["/900/image2"],
        shipment: 11.99,
        link: "/tienda/libros/pack-temari-guardia-urbana-2025/",
        more_info: true,
        can_be_sent: true,
        items: 3,
        created_at: "2025-07-24 00:00:01",
        start_at: "2025-07-24 00:00:01",
        updated_at: "2025-06-28 00:00:01",
        weight: 3215,
        shipping_price: 11.99,
    },
    // Les 1001 preguntes imprescindibles per ser Mosso d'Esquadra
    {
        id: 901,
        tax: 0.04,
        sku: "iopos.book.les-1001-preguntes-imprescindibles-per-ser-mossos-desquadra",
        title: "Les 1001 preguntes imprescindibles per ser Mosso d'Esquadra",
        name: "Les 1001 preguntes imprescindibles per ser Mosso d'Esquadra",
        description: "Una eina definitiva per dominar l'examen de coneixements. Aquest llibre recopila 1001 preguntes test reals i actualitzades, fidelment alineades amb el temari oficial de la convocatòria de Mossos d'Esquadra.",
        enabled: true,
        stock: true,
        stock_message: "Sense estoc temporalment.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos],
        price: 29.99,
        offer: 59.99,
        offer_text: "Últimes unitats!",
        images: ["/901/image4"],
        banner: ["/901/image4"],
        shipment: 4.49,
        link: "/tienda/libros/les-1001-preguntes-imprescindibles-per-ser-mosso-desquadra/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [130], duration: 12 },
        created_at: "2025-06-28 00:00:08",
        start_at: "2025-06-28 00:00:08",
        limit: 50,
        weight: 700,
    },
    // Pack GUB Total (2025/2026)
    {
        id: 902,
        tax: 0.04,
        sku: "iopos.book.pack.gub-total-2026",
        title: "Pack GUB Total 2026",
        name: "Pack GUB Total 2026",
        description: "Tot el que necessites per aprovar la GUB 2026 en un sol pack: temari actualitzat, 1001 preguntes tipus test i accés a l'app interactiva. Prepara't amb garanties i marca la diferència!",
        enabled: true,
        stock: false,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB, product_types_1.Category.Packs],
        price: 149.99,
        offer: 179.99,
        offer_text: "Estalvia diners amb els packs iOpos!",
        shipment: 4.49,
        images: ["/902/image1"],
        banner: ["/902/image1"],
        link: "/tienda/libros/pack-gub-total-2026",
        created_at: "2025-07-10 09:00:01",
        start_at: "2025-07-10 09:00:01",
        more_info: true,
        can_be_sent: true,
        items: 4,
        discount_not_applicable: true,
        pack: true,
        app: { modules: [132], duration: 12 },
        pack_items: [900, 899],
        note: "Pack GUB Total (Temari + 1001 GUB)",
        weight: 3938,
        shipping_price: 11.99,
    },
    // Curs Presencial Mossos d'Esquadra 2025 (30 hores - Diumenges Setembre/Octubre)
    {
        id: 903,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-30-hores-diumenges-setembre-octubre",
        title: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Diumenges Setembre/Octubre)",
        name: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Diumenges Setembre/Octubre)",
        short: "5) Grup 30 hores els Diumenges (Setembre/Octubre)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "El curs més intensiu, pràctic i complet per superar amb èxit les proves de Mossos d'Esquadra.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 289.99,
        // offer: 289.99,
        // offer_text: "Promoció Mossos 2025!",
        shipment: 0.0,
        images: ["/687/image2"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-30-hores/",
        created_at: "2025-04-22 00:00:10",
        start_at: "2025-04-22 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2613], limit: 30 },
        parent: 687,
    },
    // Tutorització Presencial Mossos d'Esquadra 2025 (7 Setembre)
    {
        id: 904,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-mossos-2025-7-setembre",
        title: "Tutorització Presencial Mossos d'Esquadra 2025 (7 Setembre)",
        name: "Tutorització Presencial Mossos d'Esquadra 2025 (7 Setembre)",
        short: "1.) Tutorització Mossos d'Esquadra 07-09-25 (16-21 h)",
        description: "Posa't a prova com mai abans! 💪🔥 En només 5 hores, prepara totes les parts de l'oposició amb docents especialitzats i una metodologia única. Reserva la teva plaça ara i assegura el teu futur!",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        shipment: 0.0,
        images: ["/677/image2"],
        banner: ["/677/image2"],
        created_at: "2025-07-07 00:00:01",
        start_at: "2025-07-07 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["txema@iopos.academy"],
        parent: 834,
        default_in_parent: true,
    },
    // Pack Madrid Esencial (2026)
    {
        id: 905,
        tax: 0.21,
        sku: "iopos.book.pack.pack-madrid-esencial-2026",
        title: "Pack Madrid Esencial (2026)",
        name: "Pack Madrid Esencial (2026)",
        description: "Todo lo que necesitas para preparar tu oposición con éxito: un libro físico para estudiar sin distracciones y acceso digital para entrenar donde y cuando quieras",
        enabled: true,
        stock: true,
        stock_message: "En breve disponible",
        type: product_types_1.Type.Book,
        category: [
            product_types_1.Category.Books,
            product_types_1.Category.PMM,
            product_types_1.Category.Packs,
            product_types_1.Category.Online,
        ],
        price: 49.99,
        offer: 62.49,
        offer_text: "¡Ahorra con los packs de iOpos!",
        shipment: 4.49,
        images: ["/905/image1"],
        banner: ["/905/image1"],
        link: "/tienda/libros/pack-madrid-esencial-2026/",
        created_at: "2025-07-11 00:00:03",
        start_at: "2025-07-11 00:00:03",
        more_info: true,
        can_be_sent: true,
        items: 1,
        discount_not_applicable: true,
        pack: true,
        pack_items: [523],
        app: { modules: [126, 96, 83, 127], duration: 3 },
        note: "Pack Madrid Esencial (Libro 500)",
        weight: 352,
    },
    // Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dimarts i Dijous de Setembre)
    {
        id: 906,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-30-hores-dimarts-dijous-setembre",
        title: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dimarts i Dijous de Setembre)",
        name: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dimarts i Dijous de Setembre)",
        short: "6) Grup 30 hores els Dimarts i Dijous (Setembre/Octubre)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "El curs més intensiu, pràctic i complet per superar amb èxit les proves de Mossos d'Esquadra.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 289.99,
        // offer: 289.99,
        // offer_text: "Promoció Mossos 2025!",
        shipment: 0.0,
        images: ["/687/image2"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-30-hores/",
        created_at: "2025-04-22 00:00:10",
        start_at: "2025-04-22 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2616], limit: 30 },
        parent: 687,
        default_in_parent: true,
    },
    // Curs Online Psicotècnics Aptitudinals 2025 + Campus Online (12 hores)
    {
        id: 907,
        tax: 0.21,
        sku: "iopos.course.online.curs-psicotecnics-apt-online-12-hores-2025",
        title: "Curs Online Psicotècnics Aptitudinals 2025 + Campus Online (12 hores)",
        name: "Curs Online Psicotècnics Aptitudinals 2025 + Campus Online (12 hores)",
        description: "Domina els psicotècnics en només 3 sessions intensives, en directe i amb accés al campus.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        price: 54.99,
        offer: 109.99,
        offer_text: "Aprofita aquest gran descompte!",
        images: ["/907/image1"],
        banner: ["/907/image1"],
        link: "/tienda/cursos/curs-online-psicotecnics-aptitudinals-12-hores-2025/",
        created_at: "2025-07-16 00:00:03",
        start_at: "2025-07-16 00:00:03",
        more_info: true,
        items: 1,
        evolmind: { course_id: 72, group_id: [2619] },
    },
    // Curs Presencial Psicotècnics Aptitudinals (20 hores - 4 dies)
    {
        id: 908,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-psicotecnics-aptitudinals-2025-20-hores",
        title: "Curs Presencial Psicotècnics Aptitudinals (20 hores - 4 dies)",
        name: "Curs Presencial Psicotècnics Aptitudinals (20 hores - 4 dies)",
        description: "Domina els psicotècnics en temps rècord amb el nostre curs intensiu presencial de 20 hores — amb metodologia pròpia, exercicis actualitzats i simulacres reals!",
        enabled: false,
        stock: false,
        stock_message: "Sense estoc",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        price: 189.99,
        images: ["/908/image1"],
        banner: ["/908/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-2025-20-hores/",
        created_at: "2025-07-16 00:00:03",
        start_at: "2025-07-16 00:00:03",
        more_info: true,
        items: 1,
        limit: 30,
        evolmind: { course_id: 355, group_id: [2622], limit: 30 },
    },
    // Les 1001 preguntes imprescindibles de Cultura General
    {
        id: 909,
        tax: 0.04,
        sku: "iopos.book.les-1001-preguntes-imprescindibles-cultura-general",
        title: "Les 1001 preguntes imprescindibles de Cultura General",
        name: "Les 1001 preguntes imprescindibles de Cultura General",
        description: "Domina la prova de cultura amb les 1001 preguntes que realment cauen als exàmens oficials.",
        enabled: true,
        stock: true,
        stock_message: "Disponible a partir del 19 d'agost!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB],
        price: 59.99,
        // offer: 59.99,
        // offer_text: "Oferta de llançament les 100 primeres unitats! Enviaments a partir del 21 d'agost.",
        images: ["/909/image1"],
        banner: ["/909/image1"],
        shipment: 4.49,
        link: "/tienda/libros/les-1001-preguntes-imprescindibles-de-cultura-general/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [133], duration: 12 },
        created_at: "2025-08-18 00:00:01",
        start_at: "2025-08-18 00:00:01",
        updated_at: "2025-08-18 00:00:01",
        limit: 100,
        weight: 418,
    },
    // Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre)
    {
        id: 910,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-ultra-intensiu-mixt-gub-set-oct-2025",
        title: "Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre)",
        name: "Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre)",
        description: "Prepara't per aprovar amb el mètode que funciona: el 79% dels que ho van aconseguir l'última convocatòria ho van fer amb iOpos. Ara et toca a tu.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.GUB],
        price: 299.99,
        offer: 349.99,
        offer_text: "Descompte especial durant 24 hores!",
        images: ["/910/image1"],
        banner: ["/910/image1"],
        link: "/tienda/cursos/curs-ultra-intensiu-mixt-gub-setembre-octubre-2025/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2025-07-27 00:00:01",
        start_at: "2025-07-23 00:00:01",
        updated_at: "2025-07-23 00:00:01",
        limit: 30,
        evolmind: { course_id: 313, group_id: [2625] },
    },
    // Pack Sabelotodo 2025
    {
        id: 911,
        tax: 0.21,
        sku: "iopos.book.pack.pack-sabelotodo-2026",
        title: "Pack Sabelotodo 2026",
        name: "Pack Sabelotodo 2026",
        description: "Supera amb èxit la prova de cultura: estudia només el que cau, practica intensament i aconsegueix plaça amb el pack 1001 Cultura General.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB, product_types_1.Category.Packs],
        price: 99.99,
        offer: 119.98,
        offer_text: "¡Ahorra con los packs de iOpos!",
        shipment: 4.49,
        images: ["/911/image1"],
        banner: ["/911/image1"],
        link: "/tienda/libros/pack-sabelotodo-2026/",
        created_at: "2025-07-11 00:00:03",
        start_at: "2025-07-11 00:00:03",
        more_info: true,
        can_be_sent: true,
        items: 1,
        discount_not_applicable: true,
        pack: true,
        pack_items: [909],
        app: { modules: [133, 70], duration: 6 },
        note: "Pack Sabelotodo (1001 Cultura)",
        weight: 418,
        shipping_price: 5.99,
    },
    // Pla iOpos Formatiu Total
    {
        id: 912,
        tax: 0.21,
        sku: "iopos.course.online.ref-plan-iopos-formatiu-total",
        title: "Pla iOpos Formatiu Total",
        name: "Pla iOpos Formatiu Total",
        category: [product_types_1.Category.PLANES],
        description: "Aconsegueix l'APTE a la primera amb el pla formatiu més complet, personalitzat i efectiu del mercat — tot inclòs i amb un 95% d'èxit entre els nostres alumnes.",
        enabled: true,
        stock: true,
        stock_message: "Sin stock.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 1999.99,
        split_payment: "Divideix el pagament en 3 còmodes quotes de 666,33 €!",
        shipment: 0.0,
        images: ["/912/image1"],
        banner: ["/912/image1"],
        link: "/tienda/cursos/pla-iopos-formatiu-total/",
        created_at: "2026-12-31 00:00:12",
        start_at: "2026-12-31 00:00:12",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
    },
    // Simulacre d'Entrevista 2025 (1:00 h)
    {
        id: 913,
        tax: 0.0,
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.PL,
            product_types_1.Category.FASE3,
        ],
        sku: "iopos.course.ref-2021-entrevista-personal-roleplay-2025",
        title: "Simulacre d'Entrevista 2025 (1:00 h)",
        name: "Simulacre d'Entrevista 2025 (1:00 h)",
        description: "Prepara't amb els millors i afronta la teva entrevista amb seguretat. Reserva el teu simulacre ara!",
        enabled: false,
        stock: false,
        special_buy: "/tienda/cursos/simulacre-dentrevista-policial-2025-1h/#disponibles",
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/241/image5"],
        banner: ["/241/image5"],
        link: "/tienda/cursos/simulacre-dentrevista-policial-policia-local-2025-1h/",
        created_at: "2025-07-30 00:00:01",
        start_at: "2025-07-30 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre) - Oferta
    {
        id: 914,
        hidden: true,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-ultra-intensiu-mixt-gub-set-oct-2025-oferta",
        title: "Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre)",
        name: "Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre)",
        description: "Prepara't per aprovar amb el mètode que funciona: el 79% dels que ho van aconseguir l'última convocatòria ho van fer amb iOpos. Ara et toca a tu.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.GUB],
        price: 299.99,
        // offer: 349.99,
        // offer_text: "",
        images: ["/910/image1"],
        banner: ["/910/image1"],
        link: "/tienda/cursos/curs-ultra-intensiu-mixt-gub-setembre-octubre-2025-oferta/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2025-08-08 00:00:01",
        start_at: "2025-08-08 00:00:01",
        updated_at: "2025-08-08 00:00:01",
        limit: 30,
        evolmind: { course_id: 313, group_id: [2625] },
        discount_not_applicable: true,
    },
    // Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre) - Oferta 2
    {
        id: 915,
        hidden: true,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-ultra-intensiu-mixt-gub-set-oct-2025-of",
        title: "Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre)",
        name: "Curs Ultra Intensiu Mixt - Guàrdia Urbana de Barcelona 2025 (Setembre/Octubre)",
        description: "Prepara't per aprovar amb el mètode que funciona: el 79% dels que ho van aconseguir l'última convocatòria ho van fer amb iOpos. Ara et toca a tu.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.GUB],
        price: 279.99,
        // offer: 349.99,
        // offer_text: "",
        images: ["/910/image1"],
        banner: ["/910/image1"],
        link: "/tienda/cursos/curs-ultra-intensiu-mixt-gub-setembre-octubre-2025-of/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2025-08-12 00:00:01",
        start_at: "2025-08-12 00:00:01",
        updated_at: "2025-08-12 00:00:01",
        limit: 30,
        evolmind: { course_id: 313, group_id: [2625] },
        discount_not_applicable: true,
    },
    // Campus Espai Bulevard 39a Promoció (2025/2026)
    {
        id: 916,
        tax: 0.0,
        sku: "iopos.course.f2f.campus-espai-bulevard-39a-promocio",
        title: "Campus Espai Bulevard 39a Promoció (2025/2026)",
        name: "Campus Espai Bulevard 39a Promoció (2025/2026)",
        description: "Prepara't amb la formació pionera que ha aconseguit resultats extraordinaris: 8 sessions pràctiques, campus virtual i docents de referència per arribar 100x100 preparat a l'ISPC.",
        enabled: false,
        stock: false,
        stock_message: "Grup complet!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 299.99,
        // offer: 299.99,
        // offer_text: "Oferta exclusiva les 25 primeres matrícules!",
        images: ["/916/image1"],
        banner: ["/916/image1"],
        link: "/tienda/cursos/campus-espai-bulevard-39a-promocio-2025-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2025-08-19 00:00:01",
        start_at: "2025-08-19 00:00:01",
        updated_at: "2025-08-19 00:00:01",
    },
    // Las 1001 preguntas imprescindibles para Policía Nacional
    {
        id: 917,
        tax: 0.04,
        sku: "iopos.book.las-1001-preguntas-imprescindibles-policia-nacional",
        title: "Las 1001 preguntas imprescindibles para Policía Nacional",
        name: "Las 1001 preguntas imprescindibles para Policía Nacional",
        description: "",
        enabled: false,
        stock: false,
        stock_message: "",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB],
        price: 59.99,
        // offer: 59.99,
        // offer_text: "Oferta de llançament les 100 primeres unitats! Enviaments a partir del 21 d'agost.",
        images: ["/909/image1"],
        banner: ["/909/image1"],
        shipment: 4.49,
        link: "/tienda/libros/las-1001-preguntes-imprescindibles-para-policia-nacional/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [135], duration: 12 },
        created_at: "2025-08-26 00:00:01",
        start_at: "2025-08-26 00:00:01",
        updated_at: "2025-08-26 00:00:01",
        limit: 100,
    },
    // Campus Espai Bulevard 39a Promoció (2025/2026) [Grup 2: Dissabtes de 19 a 22]
    {
        id: 918,
        tax: 0.0,
        sku: "iopos.course.f2f.campus-espai-bulevard-39a-promocio-grup-2",
        title: "Campus Espai Bulevard 39a Promoció (2025/2026) [Grup 2: Dissabtes de 19 a 22]",
        name: "Campus Espai Bulevard 39a Promoció (2025/2026) [Grup 2: Dissabtes de 19 a 22]",
        description: "Prepara't amb la formació pionera que ha aconseguit resultats extraordinaris: 8 sessions pràctiques, campus virtual i docents de referència per arribar 100x100 preparat a l'ISPC.",
        enabled: false,
        stock: false,
        stock_message: "Grup complet!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 299.99,
        // offer: 299.99,
        // offer_text: "Oferta exclusiva les 25 primeres matrícules!",
        images: ["/918/image1"],
        banner: ["/918/image1"],
        link: "/tienda/cursos/campus-espai-bulevard-39a-promocio-2025-2026-grup2/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2025-08-31 00:00:01",
        start_at: "2025-08-31 00:00:01",
        updated_at: "2025-08-31 00:00:01",
        evolmind: { course_id: 894, group_id: [2637] },
    },
    // Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dissabtes Octubre/Novembre)
    {
        id: 919,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-30-hores-dissabtes-octubre-novembre",
        title: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dissabtes Octubre/Novembre)",
        name: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dissabtes Octubre/Novembre)",
        short: "7) Grup 30 hores els Dissabtes (Octubre/Novembre)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "El curs més intensiu, pràctic i complet per superar amb èxit les proves de Mossos d'Esquadra.",
        enabled: true,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 199.99,
        offer: 289.99,
        offer_text: "Aprofita el gran descompte!",
        shipment: 0.0,
        images: ["/687/image2"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-30-hores/",
        created_at: "2025-04-22 00:00:10",
        start_at: "2025-04-22 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2640], limit: 30 },
        parent: 687,
        default_in_parent: false,
    },
    // Curs Presencial Mossos d'Esquadra 2025 (30 hores - Diumenges Octubre/Novembre)
    {
        id: 920,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-30-hores-diumenges-octubre-novembre",
        title: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Diumenges Octubre/Novembre)",
        name: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Diumenges Octubre/Novembre)",
        short: "8) Grup 30 hores els Diumenges (Octubre/Novembre)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "El curs més intensiu, pràctic i complet per superar amb èxit les proves de Mossos d'Esquadra.",
        enabled: true,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 199.99,
        offer: 289.99,
        offer_text: "Aprofita el gran descompte!",
        shipment: 0.0,
        images: ["/687/image2"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-30-hores/",
        created_at: "2025-04-22 00:00:10",
        start_at: "2025-04-22 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2643], limit: 30 },
        parent: 687,
        default_in_parent: false,
    },
    // Curs Presencial Psicotècnics Aptitudinals (8 hores - 14 i 16 d'Octubre)
    {
        id: 921,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.psicos-aptitudinals-mossos-2025-14-16-oct-mati",
        title: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h] (14, 16 octubre de 09:30 - 13:30)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h] (14, 16 octubre de 09:30 - 13:30)",
        short: "Curs Psicotècnics (14, 16 octubre - 9:30-13:30)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Supera la prova de psicotècnics a la primera i destaca entre els aspirants!",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 109.99,
        // offer: 109.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        shipment: 0.0,
        images: ["/811/image1"],
        banner: ["/811/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-2025/",
        created_at: "2025-07-31 00:00:01",
        start_at: "2025-07-31 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 811,
        default_in_parent: false,
        limit: 30,
        evolmind: { course_id: 355, group_id: [2646] },
    },
    // Curs Presencial Psicotècnics Aptitudinals (8 hores - 14 i 16 d'Octubre)
    {
        id: 922,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.psicos-aptitudinals-mossos-2025-14-16-oct-tarda",
        title: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h] (14, 16 octubre de 15:30 - 19:30)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h] (14, 16 octubre de 15:30 - 19:30)",
        short: "Curs Psicotècnics (14, 16 octubre - 15:30-19:30)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Supera la prova de psicotècnics a la primera i destaca entre els aspirants!",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 109.99,
        // offer: 109.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        shipment: 0.0,
        images: ["/811/image1"],
        banner: ["/811/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-2025/",
        created_at: "2025-07-31 00:00:01",
        start_at: "2025-07-31 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 811,
        default_in_parent: false,
        limit: 30,
        evolmind: { course_id: 355, group_id: [2649] },
    },
    // Tutorització Presencial Mossos d'Esquadra 2025 (5 octubre)
    {
        id: 923,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-mossos-2025-5-octubre",
        title: "Tutorització Presencial Mossos d'Esquadra 2025 (5 octubre)",
        name: "Tutorització Presencial Mossos d'Esquadra 2025 (5 octubre)",
        short: "2.) Tutorització Mossos d'Esquadra 05-10-25 (16-21 h)",
        description: "Posa't a prova com mai abans! 💪🔥 En només 5 hores, prepara totes les parts de l'oposició amb docents especialitzats i una metodologia única. Reserva la teva plaça ara i assegura el teu futur!",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        shipment: 0.0,
        images: ["/677/image2"],
        banner: ["/677/image2"],
        created_at: "2025-09-07 00:00:01",
        start_at: "2025-09-07 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["txema@iopos.academy"],
        parent: 834,
        default_in_parent: false,
    },
    // Pack ISPC Total (2025/2026)
    {
        id: 924,
        tax: 0.21,
        sku: "iopos.pack.ispc-total-25-26",
        title: "Pack ISPC Total (2025/2026)",
        name: "Pack ISPC Total (2025/2026)",
        description: "Tot l'ISPC en un sol pack: estratègia, entrenament i confiança per arribar al 100%.",
        enabled: true,
        stock: false,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.ISPC, product_types_1.Category.Packs],
        price: 399.99,
        offer: 469.97,
        offer_text: "Aprofita el descompte exclusiu del pack!",
        shipment: 4.49,
        images: ["/924/image1"],
        banner: ["/924/image1"],
        link: "/tienda/libros/pack-ispc-total-2025-2026/",
        created_at: "2025-09-08 00:00:02",
        start_at: "2025-09-08 00:00:02",
        more_info: true,
        can_be_sent: true,
        items: 2,
        discount_not_applicable: true,
        pack: true,
        pack_items: [572, 918],
        app: { modules: [40], duration: 12 },
        evolmind: { course_id: 525, group_id: [2628] },
    },
    // Curs Presencial Last Week of Mossos 2025 (10 hores)
    {
        id: 925,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-lastweek-10-hores",
        title: "Curs Presencial Last Week of Mossos 2025 (10 hores)",
        name: "Curs Presencial Last Week of Mossos 2025 (10 hores)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "L'últim impuls abans de l'examen: 10 hores en 1 dia, campus exclusiu i dossier essencial — reserva la teva plaça a la LAST WEEK OF MOSSOS.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 119.99,
        // offer: 119.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        shipment: 0.0,
        images: ["/925/image1"],
        link: "/tienda/cursos/curs-presencial-last-week-of-mossos-2025/",
        created_at: "2025-09-08 00:00:10",
        start_at: "2025-09-08 00:00:10",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        childs: [928],
    },
    // Curs Presencial Last Week of Mossos 2025 (10 hores - 15 Novembre)
    {
        id: 926,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-lastweek-10-hores-15-novembre",
        title: "Curs Presencial LastWeek of Mossos 2025 (10 hores - 15 Novembre)",
        name: "Curs Presencial Last Week of Mossos 2025 (10 hores - 15 Novembre)",
        short: "1) Last Week of Mossos 15 Novembre (10 h - 09:00-14:00 i 15:00 a 20:00)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "L'últim impuls abans de l'examen: 10 hores en 1 dia, campus exclusiu i dossier essencial — reserva la teva plaça a la LAST WEEK OF MOSSOS.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 119.99,
        // offer: 119.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        shipment: 0.0,
        images: ["/925/image1"],
        link: "/tienda/cursos/curs-presencial-last-week-of-mossos-2025/",
        created_at: "2025-09-08 00:00:10",
        start_at: "2025-09-08 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2652], limit: 30 },
        parent: 925,
        default_in_parent: true,
    },
    // Curs Presencial Last Week of Mossos 2025 (10 hores - 16 Novembre)
    {
        id: 927,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-lastweek-10-hores-16-novembre",
        title: "Curs Presencial Last Week of Mossos 2025 (10 hores - 16 Novembre)",
        name: "Curs Presencial Last Week of Mossos 2025 (10 hores - 16 Novembre)",
        short: "2) Last Week of Mossos 16 Novembre (10 h - 09:00-14:00 i 15:00 a 20:00)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "L'últim impuls abans de l'examen: 10 hores en 1 dia, campus exclusiu i dossier essencial — reserva la teva plaça a la LAST WEEK OF MOSSOS.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 119.99,
        // offer: 119.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        shipment: 0.0,
        images: ["/925/image1"],
        link: "/tienda/cursos/curs-presencial-last-week-of-mossos-2025/",
        created_at: "2025-09-08 00:00:10",
        start_at: "2025-09-08 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2655], limit: 30 },
        parent: 925,
        default_in_parent: false,
    },
    // Curs Presencial Last Week of Mossos 2025 (10 hores - 22 Novembre)
    {
        id: 928,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-lastweek-10-hores-22-novembre",
        title: "Curs Presencial Last Week of Mossos 2025 (10 hores - 22 Novembre)",
        name: "Curs Presencial Last Week of Mossos 2025 (10 hores - 22 Novembre)",
        short: "3) Last Week of Mossos 22 Novembre (10 h - 09:00-14:00 i 15:00 a 20:00)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "L'últim impuls abans de l'examen: 10 hores en 1 dia, campus exclusiu i dossier essencial — reserva la teva plaça a la LAST WEEK OF MOSSOS.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 119.99,
        // offer: 119.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        shipment: 0.0,
        images: ["/925/image1"],
        link: "/tienda/cursos/curs-presencial-last-week-of-mossos-2025/",
        created_at: "2025-09-08 00:00:10",
        start_at: "2025-09-08 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2658], limit: 30 },
        parent: 925,
        default_in_parent: false,
    },
    // Curs Presencial Last Week of Mossos 2025 (10 hores - 23 Novembre)
    {
        id: 929,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-lastweek-10-hores-23-novembre",
        title: "Curs Presencial Last Week of Mossos 2025 (10 hores - 23 Novembre)",
        name: "Curs Presencial Last Week of Mossos 2025 (10 hores - 23 Novembre)",
        short: "4) Last Week of Mossos 23 Novembre (10 h - 09:00-14:00 i 15:00 a 20:00)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "L'últim impuls abans de l'examen: 10 hores en 1 dia, campus exclusiu i dossier essencial — reserva la teva plaça a la LAST WEEK OF MOSSOS.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 119.99,
        // offer: 119.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        shipment: 0.0,
        images: ["/925/image1"],
        link: "/tienda/cursos/curs-presencial-last-week-of-mossos-2025/",
        created_at: "2025-09-08 00:00:10",
        start_at: "2025-09-08 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2661], limit: 30 },
        parent: 925,
        default_in_parent: false,
    },
    // Campus Espai Bulevard 39a Promoció (2025/2026) [Grup 4: Diumenges de 13 a 19]
    {
        id: 930,
        tax: 0.0,
        sku: "iopos.course.f2f.campus-espai-bulevard-39a-promocio-grup-4",
        title: "Campus Espai Bulevard 39a Promoció (2025/2026) [Grup 4: Diumenges de 13 a 19]",
        name: "Campus Espai Bulevard 39a Promoció (2025/2026) [Grup 4: Diumenges de 13 a 19]",
        description: "Prepara't amb la formació pionera que ha aconseguit resultats extraordinaris: 4 sessions pràctiques, campus virtual i docents de referència per arribar 100x100 preparat a l'ISPC.",
        enabled: false,
        stock: false,
        stock_message: "Grup complet!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 299.99,
        // offer: 299.99,
        // offer_text: "Oferta exclusiva les 25 primeres matrícules!",
        images: ["/930/image1"],
        banner: ["/930/image1"],
        link: "/tienda/cursos/campus-espai-bulevard-39a-promocio-2025-2026-grup4/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2025-11-06 00:00:02",
        start_at: "2025-11-06 00:00:02",
        updated_at: "2025-11-06 00:00:02",
        evolmind: { course_id: 894, group_id: [2704] },
    },
    // Clínic d'Entrevista Competencial 2025 (21 setembre - 16:00 a 19:00)
    {
        id: 931,
        tax: 0.21,
        hidden: true,
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.PL,
            product_types_1.Category.FASE3,
        ],
        sku: "iopos.course.f2f.clinic-dentrevista-competencial-2025-21-setembre",
        title: "Clínic d'Entrevista Competencial 2025 (21 setembre - 16:00 a 19:00)",
        name: "Clínic d'Entrevista Competencial 2025 (21 setembre - 16:00 a 19:00)",
        description: "Domina l'entrevista competencial i diferencia't dels altres candidats en només 3 hores.",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 39.99,
        shipment: 0.0,
        images: ["/0/image1"],
        banner: ["/0/image1"],
        link: "/tienda/cursos/clinic-dentrevista-competencial-2025-21-setembre-ultimes/",
        created_at: "2025-09-18 00:00:01",
        start_at: "2025-09-18 00:00:01",
        more_info: true,
        items: 1,
    },
    // Clínic Preparació / Simulacre Físiques 2025 (5 octubre - 09:30 a 11:30)
    {
        id: 932,
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.clinic-preparacio-simulacre-fisiques-5-oct-2025",
        title: "Clínic Preparació / Simulacre Físiques 2025 (5 octubre - 09:30 a 11:30)",
        name: "Clínic Preparació / Simulacre Físiques 2025 (5 octubre - 09:30 a 11:30)",
        description: "Entrena com si fos el dia de les proves i aconsegueix el màxim rendiment al teu accés a la Guàrdia Urbana de Badalona.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        price: 19.99,
        shipment: 0.0,
        images: ["/932/image1"],
        banner: ["/932/image1"],
        link: "/tienda/cursos/clinic-preparacio-simulacre-fisiques-gub-5-oct-2025/",
        created_at: "2025-09-29 00:00:02",
        start_at: "2025-09-29 00:00:02",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
    },
    // Coaching Policial amb intel·ligència Emocional 2025
    {
        id: 933,
        category: [product_types_1.Category.Interviews, product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.coaching-policial-intel-ligencia-emocional-2025",
        title: "Coaching Policial amb intel·ligència Emocional 2025",
        name: "Coaching Policial amb intel·ligència Emocional 2025",
        description: "Aprèn a gestionar les emocions i l'estrès amb eines pràctiques de coaching policial que et faran sentir més segur i preparat en qualsevol situació.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        price: 129.99,
        special_buy: "/tienda/cursos/coaching-policial-intel-ligencia-emocional-2025/#disponibles",
        shipment: 0.0,
        images: ["/933/image1"],
        banner: ["/933/image1"],
        link: "/tienda/cursos/coaching-policial-intel-ligencia-emocional-2025/",
        created_at: "2025-09-29 00:00:02",
        start_at: "2025-09-29 00:00:02",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial Psicotècnics Aptitudinals (8 hores - 26 d'Octubre)
    {
        id: 934,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-26-octubre-2025",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2025 [8h] (26/10 · 9-13h / 14-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8h] (26/10 · 9-13h / 14-18h)",
        short: "1.) Curs Presencial de Psico. Apt. Mossos 2025 (26 oct. - 9:00 - 13:00, 14:00 - 18:00)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 109.99,
        shipment: 0.0,
        images: ["/934/image1"],
        banner: ["/934/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-26-octubre-2025/",
        created_at: "2025-10-01 00:00:01",
        start_at: "2025-10-01 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        parent: 939,
        default_in_parent: true,
        limit: 30,
        evolmind: { course_id: 355, group_id: [2682] },
    },
    // Tutorització Presencial Mossos d'Esquadra 2025 (9 novembre)
    {
        id: 935,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-mossos-2025-9-novembre",
        title: "Tutorització Presencial Mossos d'Esquadra 2025 (9 novembre)",
        name: "Tutorització Presencial Mossos d'Esquadra 2025 (9 novembre)",
        short: "3.) Tutorització Mossos d'Esquadra 09-11-25 (16-21 h)",
        description: "Posa't a prova com mai abans! 💪🔥 En només 5 hores, prepara totes les parts de l'oposició amb docents especialitzats i una metodologia única. Reserva la teva plaça ara i assegura el teu futur!",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        shipment: 0.0,
        images: ["/677/image2"],
        banner: ["/677/image2"],
        created_at: "2025-10-05 00:00:01",
        start_at: "2025-10-05 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["txema@iopos.academy"],
        parent: 834,
        default_in_parent: true,
    },
    // Curs Presencial Llei Orgànica 4/2015 i el Codi Penal (8 hores) [9 novembre 2025]
    {
        id: 936,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-llei-organica-4-2015-i-el-codi-penal-9-nov-2025",
        title: "Curs Presencial Llei Orgànica 4/2015 i el Codi Penal (8 hores) [9 novembre 2025]",
        name: "Curs Presencial Llei Orgànica 4/2015 i el Codi Penal (8 hores) [9 novembre 2025]",
        category: [product_types_1.Category.ISPC, product_types_1.Category.FaceToFace],
        description: "Domina la Llei de Seguretat Ciutadana i el Codi Penal amb un curs pràctic, clar i dissenyat per aprovar oposicions amb seguretat i confiança.",
        enabled: false,
        stock: false,
        stock_message: "Sense dates disponibles",
        price: 59.99,
        shipment: 0.0,
        images: ["/936/image1"],
        banner: ["/936/image1"],
        link: "/tienda/cursos/curs-presencial-llei-organica-4-2015-i-el-codi-penal-8-hores-9-novembre-2025/",
        created_at: "2025-10-08 00:00:01",
        start_at: "2025-10-08 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 411, group_id: [2685] },
    },
    // Simulacre d'Entrevista 2025 (1:00 h)
    {
        id: 937,
        tax: 0.0,
        sku: "iopos.course.f2f.simulacre-dentrevista-2025-1h",
        title: "Simulacre d'Entrevista 2025 (1:00 h)",
        name: "Simulacre d'Entrevista 2025 (1:00 h)",
        description: "Simulacres reals, feedback expert: prepara't per aprovar a la primera.",
        enabled: false,
        stock: false,
        special_buy: "/tienda/cursos/simulacre-dentrevista-2025-1h/#disponibles",
        stock_message: "En breu disponible.",
        category: [product_types_1.Category.Interviews, product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/937/image1"],
        banner: ["/937/image1"],
        link: "/tienda/cursos/simulacre-dentrevista-2025-1h/",
        created_at: "2025-10-10 00:00:01",
        start_at: "2025-10-10 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial Psicotècnics Aptitudinals (8 hores - 23 de Novembre)
    {
        id: 938,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-23-novembre-2025",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2025 [8h] (23/11 · 9-13h / 14-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8h] (23/11 · 9-13h / 14-18h)",
        short: "2.) Curs Presencial de Psico. Apt. Mossos 2025 (23 nov. - 9:00 - 13:00, 14:00 - 18:00)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 109.99,
        shipment: 0.0,
        images: ["/934/image1"],
        banner: ["/934/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-23-novembre-2025/",
        created_at: "2025-10-15 00:00:01",
        start_at: "2025-10-15 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
        evolmind: { course_id: 355, group_id: [2688] },
    },
    // Curs Presencial Psicotècnics Aptitudinals (8 hores - 23 de Novembre)
    {
        id: 939,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-2025",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h]",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h]",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2026.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-8h-2026/",
        created_at: "2026-03-16 00:00:01",
        start_at: "2026-03-16 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        childs: [
            943, 1207, 1224, 1225, 1226, 1239, 1252, 1259, 1262, 1268, 1269,
            1271, 1272,
        ],
        hero: {
            firstTitle: "Curs Presencial de Psicotècnics Aptitudinals",
            secondTitle: "Edició 2026",
            thirdTitle: "Entrena **psicotècnics** amb **metodologia d'examen real** i millora la teva **rapidesa** i **precisió** en només una **jornada intensiva**.",
            landscape: "/939/hero_h",
            portrait: "/939/hero_v",
        },
    },
    // 3ª Sessió Nivell 2 Espai Bulevard (5h - 28/02/2026)
    {
        id: 940,
        tax: 0.0,
        sku: "iopos.course.f2f.3a-sessio-espai-bulevard-5hores-28-feb-2026",
        title: "3ª Sessió Espai Bulevard (5h - 28/02/2026)",
        name: "3ª Sessió Espai Bulevard (5h - 28/02/2026)",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/3a-sessio-espai-bulevard-5hores-28-feb-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        updated_at: "2026-01-15 00:00:01",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [2752] },
    },
    // Campus Online Espai Bulevard 39a Promoció (2025/2026)
    {
        id: 941,
        tax: 0.21,
        sku: "iopos.course.online.campus-espai-bulevard-39a-promocio-25-26",
        title: "Campus Online Espai Bulevard 39a Promoció (2025/2026)",
        name: "Campus Online Espai Bulevard 39a Promoció (2025/2026)",
        description: "Forma't com un autèntic professional: tot el Bulevard, concentrat en un sol campus",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        category: [product_types_1.Category.Online, product_types_1.Category.Bulevard],
        price: 59.99,
        offer: 119.99,
        offer_text: "Sprint final cap a l'aprovat",
        offer_message: "Sprint final cap a l'aprovat",
        images: ["/941/image1"],
        banner: ["/941/image1"],
        link: "/tienda/cursos/campus-online-espai-bulevard-39a-promocio-2025-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2025-12-31 00:00:01",
        start_at: "2025-12-31 00:00:01",
        updated_at: "2025-12-31 00:00:01",
        evolmind: { course_id: 894, group_id: [2749] },
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // Curs Presencial Psicotècnics Aptitudinals (8 hores - 22 de Novembre)
    {
        id: 942,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-22-novembre-2025",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2025 [8h] (22/11 · 9-13h / 14-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8h] (22/11 · 9-13h / 14-18h)",
        short: "5.) Curs Presencial de Psico. Apt. Mossos 2025 (22 nov. - 9:00 - 13:00, 14:00 - 18:00)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 109.99,
        shipment: 0.0,
        images: ["/934/image1"],
        banner: ["/934/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-22-novembre-2025/",
        created_at: "2025-10-15 00:00:01",
        start_at: "2025-10-15 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
        default_in_parent: true,
        evolmind: { course_id: 355, group_id: [2698] },
    },
    // Curs Presencial Psicotècnics Aptitudinals (8 hores - 28 de Març)
    {
        id: 943,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA), al tratarse de una formación homologada por una entidad oficial.",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-25-abril-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (25/04 · 9-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (25/04 · 9-18h)",
        short: "1.) Presencial de Psicos. Mossos 2026 (25 abril - 9:00h a 18:00 h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 109.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-25-abril-2026/",
        created_at: "2025-11-06 00:00:01",
        start_at: "2025-11-06 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // Curs Desbloqueig Mental Físiques (Valla i Plint) 2025 [2h] (20/12/25 de 16 a 18)
    {
        id: 944,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-desbloqueig-mental-fisiques-20-desembre-2025",
        title: "Curs Desbloqueig Mental Físiques (Valla i Plint) 2025 [2h] (20/12/25 de 16 a 18)",
        name: "Curs Desbloqueig Mental Físiques (Valla i Plint) 2025 [2h] (20/12/25 de 16 a 18)",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        description: "Supera els teus bloquejos i domina la tanca i el plint amb el mètode més efectiu d'iOpos.",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/944/image1"],
        banner: ["/944/image1"],
        link: "/tienda/cursos/curs-desbloqueig-mental-fisiques-20-desembre-2025/",
        created_at: "2025-11-30 00:00:01",
        start_at: "2025-11-30 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 60,
        discount_not_applicable: true,
    },
    // Tarifa Plana Jaguar per a Mossos i GUB — Sessions físiques al CEM Besòs
    {
        id: 945,
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.proves-fisiques-tarifa-plana-jaguar-cem-besos-2025",
        title: "Tarifa Plana Jaguar per a Mossos i GUB — Sessions físiques al CEM Besòs",
        name: "Tarifa Plana Jaguar per a Mossos i GUB — Sessions físiques al CEM Besòs",
        description: "Entrena sense límits i prepara't per superar les teves físiques amb la TARIFA PLANA JAGUAR al CEM Besòs!",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        price: 129.99,
        shipment: 0.0,
        images: ["/945/image1"],
        banner: ["/945/image1"],
        link: "/tienda/cursos/tarifa-plana-jaguar-proves-fisiques-2025/",
        created_at: "2025-11-07 00:00:01",
        start_at: "2025-11-07 00:00:0!",
        more_info: true,
        can_be_sent: false,
        items: 1,
        disallow_multiple_units: true,
        discount_not_applicable: true,
    },
    // Test de Personalitat
    {
        id: 946,
        category: [product_types_1.Category.Others, product_types_1.Category.Online],
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.f2f.test-personalitat",
        title: "Test de Personalitat ",
        name: "Test de Personalitat",
        description: "",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        price: 19.99,
        shipment: 0.0,
        images: ["/0/image1"],
        banner: ["/0/image1"],
        created_at: "2025-11-07 00:00:01",
        start_at: "2025-11-07 00:00:0!",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
    },
    // Sessió Individual Espai Bulevard (6h - 09/11/2025)
    {
        id: 947,
        tax: 0.0,
        sku: "iopos.course.f2f.sessio-individual-espai-bulevard-6hores-9-nov-2025",
        title: "Sessió Individual Espai Bulevard (6h - 09/11/2025)",
        name: "Sessió Individual Espai Bulevard (6h - 09/11/2025)",
        description: "Aprèn, practica i aplica en només 6 hores allò que marcarà la diferència al teu dia a dia.",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 79.99,
        images: ["/947/image1"],
        banner: ["/947/image1"],
        link: "/tienda/cursos/sessio-individual-espai-bulevard-6hores-9-nov-2025/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        created_at: "2025-11-07 00:00:01",
        start_at: "2025-11-07 00:00:01",
        updated_at: "2025-11-07 00:00:01",
    },
    // Sessió Individual Espai Bulevard (6h - 16/11/2025)
    {
        id: 948,
        tax: 0.0,
        sku: "iopos.course.f2f.sessio-individual-espai-bulevard-6hores-16-nov-2025",
        title: "Sessió Individual Espai Bulevard (6h - 16/11/2025)",
        name: "Sessió Individual Espai Bulevard (6h - 16/11/2025)",
        description: "Aprèn, practica i aplica en només 6 hores allò que marcarà la diferència al teu dia a dia.",
        enabled: false,
        stock: true,
        stock_message: "Places exhaurides",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 79.99,
        images: ["/947/image1"],
        banner: ["/947/image1"],
        link: "/tienda/cursos/sessio-individual-espai-bulevard-6hores-16-nov-2025/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        created_at: "2025-11-09 00:00:01",
        start_at: "2025-11-09 00:00:01",
        updated_at: "2025-11-09 00:00:01",
    },
    // Curs Presencial Psicotècnics Aptitudinals (8 hores - 23 de Novembre Grup 2)
    {
        id: 949,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-23-novembre-g2-2025",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2025 [8h] (23/11 Grup 2· 9-13h / 14-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8h] (23/11 Grup 2· 9-13h / 14-18h)",
        short: "7.) Curs Presencial de Psico. Apt. Mossos 2025 (23 nov. G2 - 9:00 - 13:00, 14:00 - 18:00)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 109.99,
        shipment: 0.0,
        images: ["/934/image1"],
        banner: ["/934/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-28-novembre-2025/",
        created_at: "2025-11-06 00:00:01",
        start_at: "2025-11-06 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
        default_in_parent: false,
        evolmind: { course_id: 355, group_id: [2707] },
    },
    // Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (26 octubre 2025)
    {
        id: 950,
        tax: 0.21,
        sku: "iopos.course.online.simulacre-temari-psicos-mossos-26-octubre-2025",
        title: "Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (26 octubre 2025)",
        name: "Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (26 octubre 2025)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online, product_types_1.Category.Psicos],
        description: "Entrena com si fos l'examen real i arriba amb avantatge al dia oficial: el simulacre més complet per superar els psicotècnics dels Mossos.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        shipment: 0.0,
        images: ["/951/image1"],
        banner: ["/951/image1"],
        link: "/tienda/cursos/simulacre-online-temari-psicos-mossos-26-octubre-2025/",
        created_at: "2025-11-01 00:00:00",
        start_at: "2025-11-01 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        parent: 951,
        default_in_parent: true,
        evolmind: { course_id: 443, group_id: [2679] },
    },
    // Simulacre Online Temari i Psicotècnics Mossos d'Esquadra 2025
    {
        id: 951,
        tax: 0.21,
        sku: "iopos.course.online.simulacre-temari-psicos-mossos-2025",
        title: "Simulacre Online Temari i Psicotècnics Mossos d'Esquadra",
        name: "Simulacre Online Temari i Psicotècnics Mossos d'Esquadra",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online, product_types_1.Category.Psicos],
        description: "Entrena com si fos l'examen real i arriba amb avantatge al dia oficial: el simulacre més complet per superar els psicotècnics dels Mossos.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        shipment: 0.0,
        images: ["/951/image1"],
        banner: ["/951/image1"],
        link: "/tienda/cursos/simulacre-online-temari-psicos-mossos-2025/",
        created_at: "2025-11-01 00:00:00",
        start_at: "2025-11-01 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        // discount_not_applicable: true,
        childs: [640],
    },
    // Llibre: Les 1001 preguntes imprescindibles de l'ISPC
    {
        id: 952,
        tax: 0.04,
        sku: "iopos.book.les-1001-preguntes-imprescindibles-de-l-ispc",
        title: "Les 1001 preguntes imprescindibles de l'ISPC",
        name: "Les 1001 preguntes imprescindibles de l'ISPC",
        description: "La guia definitiva per dominar les proves de l'ISPC i aconseguir la millor nota.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.ISPC],
        price: 59.99,
        // offer: 59.99,
        // offer_text: "A per l'Oposició!",
        images: ["/952/image1"],
        banner: ["/952/image1"],
        shipment: 4.49,
        link: "/tienda/libros/les-1001-preguntes-imprescindibles-de-l-ispc/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [136], duration: 12 },
        created_at: "2025-11-27 00:00:01",
        start_at: "2025-11-27 00:00:01",
        updated_at: "2025-11-27 00:00:01",
        weight: 700,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026
    {
        id: 953,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Exempt de l'IVA segons l'article 20.uno.20ª de la Llei 37/1992, de 28 de desembre, de l'IVA.",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-ho",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 (Hospitalet)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 (Hospitalet)",
        description: "Entrena la tercera prova amb mètode iOpos: claredat, pràctica i resultats",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-03 00:00:01",
        start_at: "2025-12-03 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        childs: [969, 1160, 1164],
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 1
    {
        id: 954,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g1",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 1] (24/01/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 1] (24/01/26 9-14 h)",
        short: "1. Curs Preparació Tercera Prova Mossos 2026 [Grup 1] [24/01/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2117],
        },
        limit: 30,
        sendPersonalityTestLink: true,
        default_in_parent: true,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 2
    {
        id: 955,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g2",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 2] (24/01/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 2] (24/01/26 15-20 h)",
        short: "2. Curs Preparació Tercera Prova Mossos 2026 [Grup 1] [24/01/26 15-20 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2120],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 3
    {
        id: 956,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g3",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 3] (25/01/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 3] (25/01/26 9-14 h)",
        short: "3. Curs Preparació Tercera Prova Mossos 2026 [Grup 3] [25/01/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2123],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 4
    {
        id: 957,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g4",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 4] (25/01/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 4] (25/01/26 15-20 h)",
        short: "4. Curs Preparació Tercera Prova Mossos 2026 [Grup 4] [25/01/26 15-20 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2126],
        },
        sendPersonalityTestLink: true,
        limit: 30,
        default_in_parent: true,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 5
    {
        id: 958,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g5",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 5] (31/01/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 5] (31/01/26 9-14 h)",
        short: "5. Curs Preparació Tercera Prova Mossos 2026 [Grup 5] [31/01/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2129],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 6
    {
        id: 959,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g6",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 6] (31/01/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 6] (31/01/26 15-20 h)",
        short: "6. Curs Preparació Tercera Prova Mossos 2026 [Grup 6] [31/01/26 15-20 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2132],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 7
    {
        id: 960,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g7",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 7] (01/02/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 7] (01/02/26 9-14 h)",
        short: "7. Curs Preparació Tercera Prova Mossos 2026 [Grup 7] [01/02/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2135],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 8
    {
        id: 961,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g8",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 8] (01/02/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 8] (01/02/26 15-20 h)",
        short: "8. Curs Preparació Tercera Prova Mossos 2026 [Grup 8] [01/02/26 15-20 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2138],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 9
    {
        id: 962,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g9",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 9] (07/02/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 9] (07/02/26 9-14 h)",
        short: "9. Curs Preparació Tercera Prova Mossos 2026 [Grup 9] [07/02/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2141],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 10
    {
        id: 963,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g10",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 10] (07/02/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 10] (07/02/26 15-20 h)",
        short: "10. Curs Preparació Tercera Prova Mossos 2026 [Grup 10] [07/02/26 15-20 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2144],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 11
    {
        id: 964,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g11",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 11] (08/02/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 11] (08/02/26 9-14 h)",
        short: "11. Curs Preparació Tercera Prova Mossos 2026 [Grup 11] [08/02/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2147],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 12
    {
        id: 965,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g12",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 12] (08/02/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 12] (08/02/26 15-20 h)",
        short: "12. Curs Preparació Tercera Prova Mossos 2026 [Grup 12] [08/02/26 15-20 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2713],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 13
    {
        id: 966,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g13",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 13] (14/02/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 13] (14/02/26 9-14 h)",
        short: "13. Curs Preparació Tercera Prova Mossos 2026 [Grup 13] [14/02/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2716],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 14
    {
        id: 967,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g14",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 14] (14/02/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 14] (14/02/26 15-20 h)",
        short: "14. Curs Preparació Tercera Prova Mossos 2026 [Grup 14] [14/02/26 15-20 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2719],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 15
    {
        id: 968,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g15",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 15] (15/02/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 15] (15/02/26 9-14 h)",
        short: "15. Curs Preparació Tercera Prova Mossos 2026 [Grup 15] [15/02/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2722],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 16
    {
        id: 969,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g16",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 16] (15/02/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 16] (15/02/26 15-20 h)",
        short: "16. Curs Preparació Tercera Prova Mossos 2026 [Grup 16] [15/02/26 15-20 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2725],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 17
    {
        id: 970,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g17",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 17] (17/01/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 17] (17/01/26 9-14 h)",
        short: "17. Curs Preparació Tercera Prova Mossos 2026 [Grup 17] [17/01/26 9-14 h]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2728],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 18
    {
        id: 971,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g18",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 18] (17/01/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 18] (17/01/26 15-20 h)",
        short: "18. Curs Preparació Tercera Prova Mossos 2026 [Grup 18] [17/01/26 15-20 h]",
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2731],
        },
        sendPersonalityTestLink: true,
        limit: 30,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 19
    {
        id: 972,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g19",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 19] (18/01/26 9-14 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 19] (18/01/26 9-14 h)",
        short: "19. Curs Preparació Tercera Prova Mossos 2026 [Grup 19] [18/01/26 9-14 h]",
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2734],
        },
        sendPersonalityTestLink: true,
        limit: 30,
        default_in_parent: true,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 20
    {
        id: 973,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g20",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 20] (18/01/26 15-20 h)",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 20] (18/01/26 15-20 h)",
        short: "20. Curs Preparació Tercera Prova Mossos 2026 [Grup 20] [18/01/26 15-20 h]",
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2737],
        },
        sendPersonalityTestLink: true,
        limit: 30,
        default_in_parent: true,
    },
];
exports.default = products;
